import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { DataHubService } from 'src/core/services/datahub';
import { ClickContentSearchSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentSearchSchema';
import { Field } from 'src/shared/components/form/field';
import { Icon } from 'src/shared/components/icon';
import { useDebounce } from 'src/shared/hooks/useDebounce';
export function Search({ onSearch }) {
    const { t } = useTranslation();
    const [value, setValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const debouncedValue = useDebounce(value);
    useEffect(function handleSearchEffect() {
        onSearch(debouncedValue);
    }, [debouncedValue, onSearch]);
    function handleFocus() {
        setIsFocused(true);
        DataHubService.sendEvent({
            schema: new ClickContentSearchSchema()
        });
    }
    return (_jsxs(Field, { iconPosition: "end", className: clsx(`relative overflow-hidden transition-all duration-300 ease-in-out [--hc-form-field-margin-bottom:0]`, {
            'w-9': !isFocused,
            'w-full min-[1320px]:w-[288px]': isFocused
        }), children: [_jsx(Icon, { icon: faSearch, className: "pointer-events-none absolute right-1 top-3 w-8 bg-neutral-100 text-large" }), _jsx("input", { value: value, onFocus: handleFocus, onBlur: () => !value && setIsFocused(false), onChange: (event) => setValue(event.target.value), onTransitionEnd: () => setIsExpanded(isFocused), placeholder: isFocused ? t('content_list.tools.search') : '', className: clsx({
                    '[--hc-form-field-padding:var(--spacer-2)var(--spacer-8)var(--spacer-2)var(--spacer-4)]': isExpanded && isFocused
                }) })] }));
}
